import type { Bounds, Filter, Rectangle } from 'pixi.js';
import { FilterSystem } from 'pixi.js';

interface FilterBoundsData {
    bounds: Bounds;
    skip: boolean;
    filters: Filter[];
}

type CalculateFilterBounds = (
    this: FilterSystem,
    filterData: FilterBoundsData,
    viewPort: Rectangle,
    rootAntialias: boolean,
    rootResolution: number,
    paddingMultiplier: number,
) => void;

const filterSystemPrototype = FilterSystem.prototype as unknown as {
    _calculateFilterBounds: CalculateFilterBounds;
};

const calculateFilterBounds = filterSystemPrototype._calculateFilterBounds;

filterSystemPrototype._calculateFilterBounds = function (
    filterData,
    viewPort,
    rootAntialias,
    rootResolution,
    paddingMultiplier,
) {
    calculateFilterBounds.call(
        this,
        filterData,
        viewPort,
        rootAntialias,
        rootResolution,
        paddingMultiplier,
    );
    if (filterData.skip || filterData.filters.some((filter) => !filter.clipToViewport)) {
        return;
    }
    filterData.bounds.fitBounds(
        0,
        viewPort.width / rootResolution,
        0,
        viewPort.height / rootResolution,
    );
};
